import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-portlet',
  templateUrl: './portlet.component.html',
  styleUrls: ['./portlet.component.scss']
})

export class PortletComponent implements OnInit {
  defaultOptions = {
    title: '',
    color: 'transparent',
    text: '',
    headerClass: 'h5 m-0 p-2 border-0 header-title',
    hideClose: true,
    loading: false,
    isVisible: true,
    hideCollapse: true
  }
  @Input() options: any = {}
  @Input() loading = false;

  // tslint:disable-next-line: no-output-on-prefix
  @Output() onContentRefresh: EventEmitter<any> = new EventEmitter();
  isLoading: boolean;
  constructor() { }

  ngOnInit() {
    Object.keys(this.defaultOptions).forEach(key => {
      if (!this.options[key]) {
        this.options[key] = this.defaultOptions[key];
      }
    })
    if (typeof this.options.isVisible === 'undefined') {
      this.options.isVisible = true;
    }
    // set the value
  }

  /**
   * Refreshes the content
   */
  refreshContent() {
    this.onContentRefresh.emit();
  }

  /**
   * Removes self from dom
   */
  remove() {
    this.options.isVisible = false;
  }

}


